import { render, staticRenderFns } from "./Commande.vue?vue&type=template&id=ae5a6098&scoped=true"
import script from "./Commande.vue?vue&type=script&lang=js"
export * from "./Commande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5a6098",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae5a6098')) {
      api.createRecord('ae5a6098', component.options)
    } else {
      api.reload('ae5a6098', component.options)
    }
    module.hot.accept("./Commande.vue?vue&type=template&id=ae5a6098&scoped=true", function () {
      api.rerender('ae5a6098', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Commande.vue"
export default component.exports